import { environment } from 'src/environments/environment';
import ignoreErrors from './ignoreErrors';
import Monitoring from './base';
import { release } from 'src/environments/release';

const monitoring = new Monitoring({
  token:
    'eyJpbnRlZ3JhdGlvbklkIjoiZWExMzM0NjAtY2RiYy00YzA2LWI0NDctYzg3ZTllZTY2MGY4Iiwic2VjcmV0IjoiYTQzN2E2YzMtZmMxNS00M2E4LTg5ZGEtNDgwZDM4YzZhYjA4In0=',
  release,
  isEnabled: environment.isMonitoringEnabled,
  ignoreErrors,
  context: {
    environment: environment.name,
  },
});

monitoring.init();

export default monitoring;
